/**
 * A signer's own block under their name on the assessment and the letter
 * (0239): one paragraph per line, in order, and nothing at all when the
 * block is empty, so the name stands alone.
 */
import type { ReactNode } from 'react';

export function SignatureBlockLines({ block }: { block: string }): ReactNode {
  const lines = block.split('\n');
  if (block.trim() === '') return null;
  return (
    <>
      {lines.map((line, i) => (
        <p key={i} data-testid="signature-block-line">
          {line}
        </p>
      ))}
    </>
  );
}
